import { ReactNode, memo } from 'react';
import ReactSelect, {
  Props as ReactSelectProps,
  GroupBase,
} from 'react-select';
import AsyncSelect, { AsyncProps } from 'react-select/async';

import { getCustomStyles, SelectWrapper, Label, ErrorText } from './styled';

type Props<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = {
  isAsync?: boolean;
  label?: ReactNode | string;
  errorText?: string;
} & (
  | ReactSelectProps<Option, IsMulti, Group>
  | AsyncProps<Option, IsMulti, Group>
);

const Select = <
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  isAsync = false,
  label,
  errorText,
  styles,
  ...props
}: Props<Option, IsMulti, Group>) => {
  return (
    <SelectWrapper>
      {!label ? null : typeof label === 'string' ? (
        <Label>{label}</Label>
      ) : (
        label
      )}
      {isAsync ? (
        <AsyncSelect<Option, IsMulti, Group>
          styles={{
            ...getCustomStyles<Option, IsMulti, Group>(!!errorText),
            ...styles,
          }}
          classNamePrefix='react-select'
          {...props}
        />
      ) : (
        <ReactSelect<Option, IsMulti, Group>
          styles={{
            ...getCustomStyles<Option, IsMulti, Group>(!!errorText),
            ...styles,
          }}
          classNamePrefix='react-select'
          {...props}
        />
      )}

      {!!errorText && <ErrorText>{errorText}</ErrorText>}
    </SelectWrapper>
  );
};

export default memo(Select);
